const COOKIE_NAME_IP_REGION = 'ip_region';

var fillInPage = (function () {
    var updateCityText = function (geoipResponse) {
        /*
         * It's possible that we won't have any names for this city.
         * For language codes with a special character such as pt-BR,
         * replace names.en with names['pt-BR'].
        */

        if (geoipResponse.subdivisions == null || geoipResponse.subdivisions.length < 1 || geoipResponse.subdivisions[0].iso_code == null) return;
        const region = geoipResponse.subdivisions[0].iso_code;
        switchRegion(region);

        var date = new Date(Date.now());
        date.setDate(date.getDate());
        date.setHours(date.getHours() + 24);
        date.setMinutes(date.getMinutes());
        date.setSeconds(0);
        date.setMilliseconds(0);
        document.cookie = `${COOKIE_NAME_IP_REGION}=${region}; path=/;` + (date != null ? ` expires=${date.toUTCString()}` : "");
    };

    var onSuccess = function (geoipResponse) {
        updateCityText(geoipResponse);
    };

    // If we get an error, we will display an error message
    var onError = function (error) {
        console.error("geoip2", error);
    };

    return function () {
        if (typeof geoip2 !== 'undefined') {
            geoip2.city(onSuccess, onError);
        } else {
            console.error("geoip2", 'a browser that blocks GeoIP2 requests');
        }
    };
}());


function switchRegion(region) {
    if (region == null) return;
    switch (region) {
        case 'SP':
            setRegionTopBar('FRETE grátis para RJ e MG');
            setRegionProduct('Envio grátis para SP, RJ e MG');
            break;
        case 'RJ':
            setRegionTopBar('FRETE grátis para RJ, SP e MG');
            setRegionProduct('Envio grátis para RJ, SP e MG');
            break;
        default:
            setRegionTopBar(`FRETE grátis para ${region}, SP e RJ`);
            setRegionProduct(`Envio grátis para ${region}, SP e RJ`);
            break;
    }
}

function setRegionTopBar(text) {
    Array.from(document.querySelectorAll('.index-section .top-bar .top-info-bar .wr-info-text a, .index-section .top-promo .promo_msg')).filter(div => div.textContent.includes('FRETE GRÁTIS'))?.forEach(e => {
        if (e == null) return;
        e.textContent = text.toUpperCase();
    })
}

function setRegionProduct(text) {
    const container = document.querySelector('.product .featured-text .ip_region p');
    if (container == null || text == null) return;
    container.innerHTML = `<strong>${text}</strong>`;
}

document.addEventListener('DOMContentLoaded', () => {
    let matches = document.cookie.match(new RegExp("(?:^|; )" + COOKIE_NAME_IP_REGION.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
    const cookieRegion = matches ? decodeURIComponent(matches[1]) : null;
    if (cookieRegion != null) {
        switchRegion(cookieRegion);
    } else {
        fillInPage();
    }
});